import OrderModel from "../models/OrderModel";
import moment from "moment";

export default [
  OrderModel.novaSequenciada(
    "AOP653",
    moment()
      .startOf("day")
      .valueOf(),
    moment()
      .startOf("day")
      .add(65, "hours")
      .valueOf(),
    "1"
  ),
  OrderModel.novaSequenciada(
    "AOP570",
    moment()
      .startOf("day")
      .add(65, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(90, "hours")
      .valueOf(),
    "1"
  ),
  OrderModel.novaSequenciada(
    "AOP572",
    moment()
      .startOf("day")
      .add(90, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(110, "hours")
      .valueOf(),
    "1"
  ),
  OrderModel.novaSequenciada(
    "AOP270",
    moment()
      .startOf("day")
      .add(8, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(20, "hours")
      .valueOf(),
    "2"
  ),
  OrderModel.novaSequenciada(
    "AOP160",
    moment()
      .startOf("day")
      .add(21, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(38, "hours")
      .valueOf(),
    "2"
  ),
  OrderModel.novoIntervalo(
    moment()
      .startOf("day")
      .add(0, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(8, "hours")
      .valueOf(),
    "3"
  ),
  OrderModel.novaSequenciada(
    "AOP960",
    moment()
      .startOf("day")
      .add(10, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(20, "hours")
      .valueOf(),
    "3"
  ),
  OrderModel.novoIntervalo(
    moment()
      .startOf("day")
      .add(20, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(23, "hours")
      .valueOf(),
    "3"
  ),
  OrderModel.novaSequenciada(
    "AOP360",
    moment()
      .startOf("day")
      .add(28, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(70, "hours")
      .valueOf(),
    "3"
  ),
  OrderModel.novaSequenciada(
    "AOP777",
    moment()
      .startOf("day")
      .add(74, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(90, "hours")
      .valueOf(),
    "3"
  ),
  OrderModel.novaSequenciada(
    "AOP888",
    moment()
      .startOf("day")
      .add(0, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(14, "hours")
      .valueOf(),
    "4"
  ),
  OrderModel.novoIntervalo(
    moment()
      .startOf("day")
      .add(14, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(18, "hours")
      .valueOf(),
    "4"
  ),
  OrderModel.novaSequenciada(
    "AOP912",
    moment()
      .startOf("day")
      .add(40, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(67, "hours")
      .valueOf(),
    "4"
  ),
  OrderModel.novoIntervalo(
    moment()
      .startOf("day")
      .add(0, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(6, "hours")
      .valueOf(),
    "5"
  ),
  OrderModel.novaSequenciada(
    "AOP022",
    moment()
      .startOf("day")
      .add(6, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(15, "hours")
      .valueOf(),
    "5"
  ),
  OrderModel.novaSequenciada(
    "AOP001",
    moment()
      .startOf("day")
      .add(16, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(20, "hours")
      .valueOf(),
    "5"
  ),
  OrderModel.novaSequenciada(
    "AOP155",
    moment()
      .startOf("day")
      .add(32, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(105, "hours")
      .valueOf(),
    "5"
  ),
  OrderModel.novaSequenciada(
    "AOP788",
    moment()
      .startOf("day")
      .add(8, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(22, "hours")
      .valueOf(),
    "6"
  ),
  OrderModel.novaSequenciada(
    "AOP891",
    moment()
      .startOf("day")
      .add(32, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(46, "hours")
      .valueOf(),
    "6"
  ),
  OrderModel.novoIntervalo(
    moment()
      .startOf("day")
      .add(70, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(76, "hours")
      .valueOf(),
    "6"
  ),
  OrderModel.novaSequenciada(
    "AOP981",
    moment()
      .startOf("day")
      .add(56, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(70, "hours")
      .valueOf(),
    "6"
  ),
  OrderModel.novaSequenciada(
    "AOP198",
    moment()
      .startOf("day")
      .add(80, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(94, "hours")
      .valueOf(),
    "6"
  ),
  OrderModel.novaSequenciada(
    "AOP842",
    moment()
      .startOf("day")
      .add(0, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(22, "hours")
      .valueOf(),
    "7"
  ),
  OrderModel.novaSequenciada(
    "AOP420",
    moment()
      .startOf("day")
      .add(72, "hours")
      .valueOf(),
    moment()
      .startOf("day")
      .add(82, "hours")
      .valueOf(),
    "7"
  ),
];
